// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__S3i46"};